<template>

  <div class="order_row toggleContainer" ref="toggleContainer" v-if="order" :orderid="order.orderID">

    <div class="order_top ease clearfix ">

      <a class="right order_top_title clearfix" href="javascript:void(0);" onclick="toggle(this)" @click="toggleOrder">
        <span class="show_icon"></span>
        <span class="show-t">הצגת הזמנה</span>
        <span class="hide-t">הסתרת הזמנה</span>
      </a>
      <div class="right order_top_date" v-if="order.meta.jckwds_date">
        <div style="text-decoration: underline;">הזמנה לתאריך:</div>
        {{ order.meta.jckwds_date[0] }}
      </div>

      <div class="right order_top_date" v-if="isGiftCardPurchaseOrder && orderPaidDate">
        <div style="text-decoration: underline;">הזמנה מתאריך:</div>
        {{ orderPaidDate }}
      </div>

      <div class="right order_top_amount">{{ numberOfProducts }} מוצרים</div>

      <div v-if="order.meta.is_permanent_order_child" class="right order-tag is_permanent_order">הזמנה קבועה</div>
      <div v-if="isGiftCardPurchaseOrder" class="right order-tag is_gift_card_purchase_order">רכישת גיפט קארד</div>

      <div class="left order_top_bt ease no_mobile" v-if="!isGiftCardPurchaseOrder">
        <a
          href="#"
          @click.prevent="addOrderToCart"
          class="hasTooltip"
          title="העתקת פריטים להזמנה חדשה"
        >
          <CART />
        </a>
      </div>

      <div class="left order_top_bt ease no_mobile" v-if="!isGiftCardPurchaseOrder">
        <a
            href="javascript:void(0);"
            class="hasTooltip"
            v-if="!this.$store.state.allowPermOrder"
            title="בקרוב: שירות הזמנה קבועה בזמן שנוח לך ובאופן קבוע"
        >
          <span>הפוך להזמנה הקבועה שלי</span>
          <ADBOOK/>
        </a>
        <a
            href="javascript:void(0);"
            @click="createPermenent"
            v-if="this.$store.state.allowPermOrder && !isGiftCardPurchaseOrder"
            class="hasTooltip"
            title="הפוך להזמנה הקבועה שלי">
          <ADBOOK/>
        </a>
      </div>

      <!-- zzz -->
      <div class="order-is-in-making right" v-if="isOrderForTodayAndNotEditable">ההזמנה בהכנה</div>

      <div class="left order_top_bt bt_loader order_edit_bt pre-open ease" :class="{active : isLoadingEdit}" v-if="order.is_edit == 1 && timeLeft">
        <a href="#" @click.prevent="editOrder">
          <span>עריכת הזמנה</span>
          <PEN/>
          <img :src="loaderSVG" alt=""/>
        </a>
      </div>
      <div class="left order_top_bt bt-download ease no_mobile" v-if="showInvoiceBtn">
        <a :href="homeUrl + '/?downloadInvoice&id='+ order.orderID" target="_blank" class="hasTooltip" title="הורדת חשבונית">
          <DOWNLOAD/>
        </a>
      </div>
      <div class="m-both"></div>
      <div class="left time-left m-100 order_top_bt" v-if="order.is_edit == 1 && timeLeft.time">
				<span class="time-left_in" :id="'time_'+order.orderID">
					נותרו
					<span id="hours" class="hours"></span>:<!--
					--><span id="minutes" class="minutes"></span>:<!--
					--><span id="seconds" class="seconds"></span>
					שעות לעריכה
					<TIMER/>
				</span>
      </div>
    </div>
    <div class="order_open toggleInner clearfix">
      <div class="both"></div>
      <div class="mobile_only m_order_bt m_order_bt-border ease">
        <a href="javascript:void(0);" @click="createPermenent" v-if="this.$store.state.allowPermOrder" style="margin-top:10px;">
					<span>
						הפוך להזמנה הקבועה שלי
						<ADBOOK/>
					</span>
        </a>
        <a href="javascript:void(0);" v-if="!this.$store.state.allowPermOrder" style="margin-top:10px;" class="hasTooltip" title="בקרוב: שירות הזמנה קבועה בזמן שנוח לך ובאופן קבוע">
					<span>
						הפוך להזמנה הקבועה שלי
						<ADBOOK/>
					</span>
        </a>
      </div>
      <div class="mobile_only m_order_bt ease"  style="margin-bottom:20px;">
        <a href="javascript:void(0);" @click.prevent="addOrderToCart">
					<span>
						העתקת פריטים להזמנה חדשה
						<CART/>
					</span>
        </a>
      </div>
      <div class="mobile_only m_order_bt m_order_bt-border ease" v-if="showInvoiceBtn">
        <a :href="homeUrl + '/?downloadInvoice&id='+ order.orderID" target="_blank">
          <!-- <a href="javascript:void(0);" class="hasTooltip" title="בקרוב" target=""> -->
          <span>
						הורדת חשבונית
						<DOWNLOAD/>
					</span>
        </a>
      </div>

      <ProductTable v-if="open" :products="order.items" :orderID="order.orderID" @select="update_addtocart_button_text"/>

      <div class="left order-button order_top_bt ease bt_green" v-if="!isGiftCardPurchaseOrder">
        <a href="#" @click.prevent="addOrderToCart" v-text="buttonText"></a>
      </div>

      <div class="gift-card-details" v-if="isGiftCardPurchaseOrder">
        <a :href="order.gift_card_pdf_link" style="text-decoration:underline">לצפייה בגיפט קארד/ים &larr;</a>
      </div>
    </div>

  </div>
</template>

<script>
import CART from "../../../assets/img/cart.svg";
import ADBOOK from "../../../assets/img/addbook2.svg";
import TIME from "../../../assets/img/time.svg";
import PEN from "../../../assets/img/pen.svg";
import DOWNLOAD from "../../../assets/img/ic-download.svg";
import ProductTable from "./ProductsTable.vue";
import {mapActions, mapMutations} from "vuex";
import TIMER from "../../../assets/img/timer.svg";
import PerPop from "../../Popups/OrderToPer";
import ExitPop from "../../Popups/ExitSalePop";

export default {
  props: ["order"],
  data() {
    return {
      products: [],
      homeUrl: wpData.home_url,
      edit: false,
      loaderGif: wpData.assets_url + "/layout/loader.gif",
      loaderSVG: wpData.assets_url + "/svg/loader.svg",
      loaderSVGreen: wpData.assets_url + "/svg/loader-green.svg",
      wpData: wpData,
      isLoadingEdit: false,
      buttonText: 'רוצה את כל ההזמנה לסל',
      selected: [],
      open: false
    }
  },
  mounted() {
    this.products = this.chunkify(this.order.items, 4);
    if (this.timeLeft) {
      var id = "time_" + this.order.orderID;
      this.initializeClock(id, this.timeLeft.to);
    }
  },
  methods: {
    ...mapActions(["getProductById", "updateCart", "clarCart"]),
    ...mapMutations(["setOrderEdit", "setOrderMeta"]),
    toggleOrder() {
      this.open = true;
    },
    chunkify(a, n, balanced) {
      if (n < 2) return [a];
      var len = a.length, out = [], i = 0, size;
      if (len % n === 0) {
        size = Math.floor(len / n);
        while (i < len) {
          out.push(a.slice(i, (i += size)));
        }
      } else if (balanced) {
        while (i < len) {
          size = Math.ceil((len - i) / n--);
          out.push(a.slice(i, (i += size)));
        }
      } else {
        n--;
        size = Math.floor(len / n);
        if (len % size === 0) size--;
        while (i < size * n) {
          out.push(a.slice(i, (i += size)));
        }
        out.push(a.slice(size * n));
      }
      return out;
    },
    getTimeRemaining(endtime) {
      var t = Date.parse(endtime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      var hours = Math.floor(t / (1000 * 60 * 60));
      return {
        total: t,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      }
    },
    addOrderToCart: function () {
      if (this.$store.state.added.length > 0) {
        this.$modal.show("order-copy", {order: this.order});
        return;
      }
      this.clarCart();

      this.order.items.map(product => {
        if (this.selected.length) {
          const index = this.selected.indexOf(product.id);
          if (index !== -1) {
            this.updateCart([product, true]);
          }
        } else {
          this.updateCart([product, true]);
        }
      });

      this.$root.$emit("orderCopy");
      setTimeout(() => {
        $(".cart").fadeIn(100, function () {
          $("body").addClass("noscroll");
          $(".cart_in").animate({left: 0}, 600);
        });
      }, 1000);

      //if (this.$store.state.outOfStock.length > 0) {
      if (this.$store.state.outOfStockCart.length > 0) {
        this.$modal.show("not-exist");
      }
      this.$router.push({path: "/"});
    },
    createPermenent() {
      this.$modal.show(PerPop, {order: this.order});
      return;

    },
    editOrder() {
      this.isLoadingEdit = true;
      this.$ajax({
        method: "POST",
        url: homeUrl + "?checkOrderStatus",
        params: {
          docNumber: this.order.meta.doc_number[0],
          orderId: this.order.orderID
        }
      }).then(res => {
        if (res.data.status == 200 && res.data.order_status) {
          this.$store.commit("setPermOrderEdit", false);
          this.$store.commit("setPremenantOrder", false);
          this.$store.commit("setPerEdit", this.order.meta.is_permanent_order_child);
          this.$router.push({
            path: this.wpData.globalOptions.order_edit_page.replace(this.wpData.home_url, ''),
            query: {
              orderID: this.order.orderID
            }
          });
          this.isLoadingEdit = false;
        }
      }).catch(e => console.log(e));
    },
    downloadURL: function (url) {
      var $idown;
      if ($idown) {
        $idown.attr("src", url);
      } else {
        $idown = $("<iframe>", {id: "idown", src: url})
            .hide()
            .appendTo("body");
      }
    },
    getInvoice() {
      this.$ajax({
        method: "POST",
        url: ajaxUrl,
        params: {
          action: "getInvoice",
          order_id: this.order.orderID
        }
      }).then(res => {
        if (res.data.success) {
          var uri = res.data.return;
          window.open(res.data.return, "_blank");
        }
      }).catch(e => console.log(e));
    },
    initializeClock(id, endtime) {
      var clock = document.getElementById(id);
      var hoursSpan = clock.querySelector(".hours");
      var minutesSpan = clock.querySelector(".minutes");
      var secondsSpan = clock.querySelector(".seconds");
      var _this = this;

      function updateClock() {
        var t = _this.getTimeRemaining(endtime);
        //console.log( t.hours );
        if (parseInt(t.hours) < 10) {
          hoursSpan.innerHTML = ("0" + t.hours);
        } else {
          hoursSpan.innerHTML = t.hours;
        }
        minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
        secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);
        if (t.total <= 0) {
          clearInterval(timeinterval);
        }
      }

      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
    },
    update_addtocart_button_text(qty) {
      this.selected = qty;
      if (qty.length>0) {
        this.buttonText = 'הוספה להזמנה';
      } else {
        this.buttonText = 'רוצה את כל ההזמנה לסל';
      }
    }
  },
  computed: {
    numberOfProducts() {
      return this.order.items.length;
    },
    timeLeft() {
      if (!this.order.is_edit) {
        return null;
      }
      if (!this.order.meta.jckwds_date[0] && !this.order.meta.jckwds_timeslot[0]) {
        return false
      }
      let date = this.order.meta.jckwds_date[0].split("/");
      let hour = this.order.meta.jckwds_timeslot[0].split(" - ")[0];
      if (date && date[2] && date[2].length == 4) {
        date[2] = date[2].substr(2);
      }

      const timeToEdit = 9;

      let string_time = "20" + date[2] + "-" + date[0] + "-" + date[1] + " " + hour + ":00";
      let to = new Date("20" + date[2], parseInt(date[1] - 1), date[0], parseInt(hour.split(":")[0] - timeToEdit), hour.split(":")[1]);
      let now = new Date();
      let time = now.getTime() < to.getTime() ? to.getTime() : false;
      if (time) {
        return {date, hour, to, time};
      }
      return false;
    },
    showInvoiceBtn() {
      if (this.isGiftCardPurchaseOrder) {
        return true;
      }
      if (!this.order.meta.jckwds_date[0] && !this.order.meta.jckwds_timeslot[0]) {
        return false;
      }
      let date = this.order.meta.jckwds_date[0].split("/");
      let hour = this.order.meta.jckwds_timeslot[0].split(" - ")[0];
      let to = new Date("20" + date[2], parseInt(date[1] - 1), date[0], parseInt(hour.split(":")[0]), hour.split(":")[1]);
      let now = new Date();
      if (now.getTime() > to.getTime()) {
        return true;
      }
      return false;
    },
    isGiftCardPurchaseOrder() {
      let res = false;
      try {
        res = this.order.meta.is_gift_card_order[0] === "1";
      } catch (error) {
        return false;
      }
      return res;

    },
    orderPaidDate() {
      let timestamp = false;
      try {
        timestamp = Date.parse(this.order.meta._paid_date[0]);
      } catch (error) {
        return false;
      }
      let date = new Date(timestamp);
      return date.toLocaleDateString("en-GB");
    },
    isOrderForTodayAndNotEditable() {

      // check if order is for today
      // Check if order is not editable
      // Check if time slot is not over
      const mustHaveData = [
        typeof this.order === 'object',
        typeof this.order.meta === 'object',
        Array.isArray(this.order.meta.jckwds_date),
        typeof this.order.meta.jckwds_date[0] === 'string',
        Array.isArray(this.order.meta.jckwds_timeslot),
        typeof this.order.meta.jckwds_timeslot[0] === 'string'
      ];

      if (mustHaveData.includes(false)) {
        return false;
      }

      const todayRaw = new Date();
      const today = todayRaw.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      });

      const orderDate = this.order.meta.jckwds_date[0];
      const isOrderForToday = orderDate === today;
      const isOrderEditable = this.timeLeft != false;
      const orderEndHour = parseInt(this.order.meta.jckwds_timeslot[0].split(' - ')[1].split(':')[0]); // example: 10
      const currentHour = parseInt(todayRaw.getHours());
      const isOrderDelivered = currentHour >= orderEndHour;

      return isOrderForToday && !isOrderEditable && !isOrderDelivered;

    }
  },
  updated() {
    this.$nextTick(() => {
      this.$store.dispatch("initToolTip");
    });
  },
  components: {
    CART,
    ADBOOK,
    TIME,
    PEN,
    DOWNLOAD,
    ProductTable,
    TIMER,
    PerPop
  }
}
</script>

<style lang="sass">
.order_row

  .order_open
    padding: 0

  .order-tag
    padding: 0.25rem 0.5rem
    font-size: 0.75rem
    border-radius: 0.25rem

  .order-is-in-making
    font-weight: bold
    color: #ea4725

  .is_permanent_order
    color: #1e824c
    font-size: 0.75rem
    padding: 0.25rem 0.5rem
    border-radius: 0.35rem
    @media screen and (max-width:800 px)
    clear: both
    display: block
    margin: 0.25rem 1.75rem 0 0

  .is_gift_card_purchase_order
    color: #989035
    background: #fffbcf
    border: 1px solid #989035

  .gift-card-details
    clear: both

    a
      display: block
      padding: 1rem

  .order-button.order_top_bt.bt_green
    margin: 0 30px 20px

    a
      color: #fff
      font-weight: normal
      margin-top: 0
      width: auto
      padding: 0 20px

      &:hover
        padding-right: 20px
        border-color: #1e824c

  &.active .order_top_bt.bt_green a:hover
    background: #fff
    color: #213519
    border-color: #213519

  .order_top_amount
    width: 8%

@media (max-width: 800px)
  .order_row .order_open
    padding: 0 15px

    .order-products
      padding-bottom: 0 !important

    .order-button.order_top_bt.bt_green
      float: none
      width: 100%
      margin: 0 0 30px

      a
        display: block

  .order_top_amount
    width: 26% !important

  .order_edit_bt a
    width: 115px


</style>
